/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1SerievideoIdQueryResponse,
  GetApiV1SerievideoIdPathParams,
  GetApiV1SerievideoIdQueryParams,
  GetApiV1SerievideoId401,
  GetApiV1SerievideoId404,
  GetApiV1SerievideoId500,
} from "../../types/serieVideoRegistroController/GetApiV1SerievideoId.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1SerievideoId } from "../../clients/serieVideoRegistroController/getApiV1SerievideoId.ts";

export const getApiV1SerievideoIdQueryKey = (
  id: GetApiV1SerievideoIdPathParams["id"],
  params?: GetApiV1SerievideoIdQueryParams,
) =>
  [
    { url: "/api/v1/serievideo/:id", params: { id: id } },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1SerievideoIdQueryKey = ReturnType<
  typeof getApiV1SerievideoIdQueryKey
>;

export function getApiV1SerievideoIdQueryOptions(
  id: GetApiV1SerievideoIdPathParams["id"],
  params?: GetApiV1SerievideoIdQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1SerievideoIdQueryKey(id, params);
  return queryOptions<
    GetApiV1SerievideoIdQueryResponse,
    ResponseErrorConfig<
      | GetApiV1SerievideoId401
      | GetApiV1SerievideoId404
      | GetApiV1SerievideoId500
    >,
    GetApiV1SerievideoIdQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1SerievideoId(id, params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna os dados de um vídeo (título/resumo/embed no idioma corrente). **(Requer Authorization para autenticação)**
 * @summary Obter vídeo por ID (Requer Authorization para autenticação)
 * {@link /api/v1/serievideo/:id}
 */
export function useGetApiV1SerievideoId<
  TData = GetApiV1SerievideoIdQueryResponse,
  TQueryData = GetApiV1SerievideoIdQueryResponse,
  TQueryKey extends QueryKey = GetApiV1SerievideoIdQueryKey,
>(
  id: GetApiV1SerievideoIdPathParams["id"],
  params?: GetApiV1SerievideoIdQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1SerievideoIdQueryResponse,
        ResponseErrorConfig<
          | GetApiV1SerievideoId401
          | GetApiV1SerievideoId404
          | GetApiV1SerievideoId500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1SerievideoIdQueryKey(id, params);

  const query = useQuery(
    {
      ...getApiV1SerievideoIdQueryOptions(id, params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1SerievideoId401
      | GetApiV1SerievideoId404
      | GetApiV1SerievideoId500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
